import { render } from "./IconLocation.vue?vue&type=template&id=2a1253fa"
const script = {}

import exportComponent from "/builds/lindner/lindner-factorytour-frontend-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__